// Service worker registration + offline status helpers
// Imported once from src/index.js — keep the API tiny.

export function registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return;
    // Note: in CRA dev mode, the SW can serve stale assets — hard-refresh (Ctrl+Shift+R)
    // if you don't see your latest code. In production builds with hashed filenames this is a non-issue.
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js', { scope: '/' })
            .then((registration) => {
                // eslint-disable-next-line no-console
                console.log('SW enregistré avec scope:', registration.scope);
            })
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.warn('SW registration failed:', err);
            });
        // When we come back online, ask the SW to flush its queue
        window.addEventListener('online', () => {
            if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ type: 'REPLAY_QUEUE' });
            }
        });
    });
}
